<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid class="week">
        <v-row style="width: 1300px">
          <v-col>
            <div id="calendar-nav">
              <v-btn
                class="glyphicon glyphicon-menu-left"
                @click="moveLastMonth()"
              >
                <v-icon>keyboard_arrow_left</v-icon>前週
              </v-btn>
              <v-btn
                class="glyphicon glyphicon-menu-right"
                @click="moveNextMonth()"
              >
                次週
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <v-btn @click="kousin"> <v-icon>update</v-icon>更新 </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="koukaiupdate"
              color="red"
              outlined
              v-if="admin() && !koukai"
            >
              <v-icon>update</v-icon>公開前、公開する</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="caldivweek">
              <table id="wcalendar" class="table table-bordered">
                <thead>
                  <tr
                    style="
                      background: white;
                      position: -webkit-sticky;
                      position: sticky;

                      top: 0;
                    "
                  >
                    <th style="background-color: navy"></th>
                    <th v-for="week in weeks" :key="week.dt">
                      {{ week.dt }} ({{ week.wnm }})
                    </th>
                  </tr>
                  <tr>
                    <th style="background-color: navy" class="white--text">
                      共通事項
                    </th>
                    <th
                      v-for="week in weeks"
                      :key="week.dt"
                      @click="holiopen(week.ydt)"
                      class="red--text"
                    >
                      {{ getmemo(week.ydt) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="staff in staffs" :key="staff.id">
                    <th style="background-color: navy; color: white">
                      {{ staff.staffname }}<br />{{ weekTime[staff.id] }}
                    </th>
                    <td v-for="(weeks, key) in eventsMap[staff.id]" :key="key">
                      <p
                        v-if="admin()"
                        class="day"
                        @click="dayopen(staff.id, key)"
                      >
                        〇
                      </p>
                      <p class="red--text text-center my-0">
                        {{ getyasumi(key, staff.id)
                        }}{{ getsyukin(key, staff.id) }}
                      </p>
                      <template v-for="event in weeks">
                        <p
                          :key="event.id"
                          class="evw"
                          :class="{ cancel: event.cancel, del: event.del }"
                          :style="{ color: event.color }"
                          @click="open(event)"
                        >
                          {{ event.rimyoji }}{{ event.riname }} {{ event.mark }}
                          <br />
                          {{ event.kaisi }}-{{ event.syuryo }}
                          <br />
                          <span v-if="event.dokoname"
                            >同行：{{ event.dokoname }}</span
                          >
                        </p>
                        <!-- <p
                          v-if="event.jid != null"
                          :key="event.id"
                          class="evw"
                          :class="{ cancel: event.cancel, del: event.del }"
                          :style="{ color: event.color }"
                        >
                          <v-icon x-small>done</v-icon> {{ event.rimyoji
                          }}{{ event.riname }}
                          {{ event.mark }}
                          <br />
                          {{ event.kaisi }}-{{ event.syuryo }}
                          <br />
                          <span v-if="event.dokoname"
                            >同行：{{ event.dokoname }}</span
                          >
                        </p> -->
                      </template>
                      <p class="text-center my-0 blue--text">
                        {{ getsyukinsita(key, staff.id) }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>

          <v-row>
            <v-dialog
              v-model="holidialog"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              width="700px"
            >
              <v-toolbar dense dark>
                <v-toolbar-title
                  >メモ（最上部に赤文字表示されます。）</v-toolbar-title
                >

                <v-spacer></v-spacer>

                <v-btn @click="holidialog = false">
                  <v-icon>close</v-icon> 閉じる
                </v-btn>
              </v-toolbar>
              <v-card>
                <v-card-actions>
                  <v-btn outlined color="info" @click="holiupdate">保存</v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-text-field v-model="holiday" label="メモ"></v-text-field>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
              v-model="syukindialog"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              width="700px"
            >
              <v-toolbar dense dark>
                <v-toolbar-title>個別メモ</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn @click="syukindialog = false">
                  <v-icon>close</v-icon> 閉じる
                </v-btn>
              </v-toolbar>
              <v-card>
                <v-card-actions>
                  <v-btn outlined color="info" @click="syukinupdate"
                    >保存</v-btn
                  >
                </v-card-actions>
                <v-card-text>
                  <v-checkbox v-model="syukinyasumi" label="休み"></v-checkbox>
                  <v-text-field
                    v-model="syukinday"
                    label="メモ（上赤文字）"
                  ></v-text-field>
                  <v-text-field
                    v-model="syukindaysita"
                    label="メモ（下青文字）"
                  ></v-text-field>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
              v-model="dialog"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              width="600px"
            >
              <v-card>
                <v-toolbar dark>
                  <v-toolbar-title>シフト変更</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn @click="dialog = false">
                    <v-icon>close</v-icon>閉じる
                  </v-btn>
                </v-toolbar>

                <v-card-text class="pt-5">
                  <v-row>
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="ev.date"
                          label="日付を選択してください"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="ev.date"
                        locale="ja"
                        @input="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xs="12" sm="6" md="4">
                      <v-select
                        v-model="ev.riid"
                        :items="riyousyas"
                        :item-text="(r) => r.rimyoji + r.riname"
                        item-value="id"
                        label="利用者"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" md="4">
                      <v-select
                        v-model="ev.staffid"
                        :items="staffs"
                        item-text="staffname"
                        item-value="id"
                        label="担当者"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" md="4">
                      <v-select
                        v-model="ev.dokoid"
                        :items="dokos"
                        item-text="staffname"
                        item-value="id"
                        label="同行者"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xs="6" sm="6">
                      <v-text-field
                        v-model="ev.kaisi"
                        label="開始時間"
                        type="time"
                        step="900"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6">
                      <v-text-field
                        v-model="ev.syuryo"
                        label="終了時間"
                        type="time"
                        step="900"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-select
                        v-model="ev.mark"
                        :items="services"
                        item-text="svname"
                        item-value="mark"
                        label="サービス区分"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6">
                      <v-select
                        v-model="ev.color"
                        :items="colors"
                        item-text="color"
                        item-value="val"
                        label="色"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn outlined color="error" @click="cancel"
                    >支援キャンセル</v-btn
                  >
                  <v-btn outlined color="error" @click="del">支援削除</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="update">変更を保存</v-btn>
                  <v-btn outlined @click="dialog = false">
                    <v-icon>close</v-icon>画面を閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
              v-model="daydialog"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              width="700px"
            >
              <v-card>
                <v-card-actions>
                  <v-btn outlined @click="daydialog = false">
                    <v-icon>close</v-icon>画面を閉じる
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="success" @click="syukinopen"
                    >メモ・休み</v-btn
                  >
                  <v-btn outlined color="success" @click="copy">コピー</v-btn>
                  <v-btn outlined color="success" @click="past">貼り付け</v-btn>
                  <v-btn outlined color="info" @click="add">新規追加</v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <template>
                          <v-data-table
                            v-model="selected"
                            :headers="headers"
                            :items="dayMap"
                            item-key="id"
                            show-select
                            disable-filtering
                            disable-pagination
                            hide-default-footer
                            @item-selected="select"
                            @toggle-select-all="toggleAll"
                          ></v-data-table>
                        </template>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-row>

          <v-snackbar v-model="snackbar" color="success" :timeout="2000">
            {{ msg }}
            <v-btn @click="snackbar = false">閉じる</v-btn>
          </v-snackbar>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Auth from "@/components/Auth";
import Common from "@/components/Common";
import moment from "moment";
export default {
  mixins: [Common, Auth],
  data: () => ({
    today: "",
    weeks: [],
    nowday: "",
    colors: [
      { color: "黒", val: "black" },
      { color: "赤", val: "red" },
      { color: "青", val: "blue" },
      { color: "緑", val: "green" },
      { color: "紫", val: "purple" },
      { color: "茶", val: "brown" }
    ],
    headers: [
      {
        text: "選択",
        align: "start",
        sortable: false,
        value: "name"
      },
      { text: "利用者名", value: "fullname" },
      { text: "開始", value: "kaisi" },
      { text: "終了", value: "syuryo" },
      { text: "担当者", value: "staffname" }
    ],
    calData: { year: 0, month: 0 },
    keyid: 0,
    menu: false,
    daymenu: false,
    dayMap: [],
    copyMap: [],
    dayDt: [],
    dayId: [],
    selected: [],
    holidays: {},
    holidialog: false,
    holiday: "",
    holidaydt: "",
    msg: "",
    snackbar: "",
    search: "",
    type: "staff",
    dialog: false,
    daydialog: false,
    jikansu: 0,
    events: [],
    eventsMap: [],
    staffs: [],
    dokos: [],
    riyousyas: [],
    services: [],
    ev: "",
    syukins: {},
    syukindialog: false,
    syukinday: "",
    syukindaysita: "",
    syukindaydt: "",
    syukinid: "",
    syukinyasumi: false,
    koukai: 0,
    weekTime: {}
  }),
  computed: {},
  watch: {
    eventsMap: {
      handler: function() {},
      deep: true
    },
    dialog(open) {
      if (open) {
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = "fixed";
      } else {
        const scrollY = document.body.style.top;
        document.body.style.position = "";
        document.body.style.top = "";
        window.scrollTo({ top: parseInt(scrollY || "0") * -1 });
      }
    }
  },
  created() {
    this.month = new Date();
    this.today = moment(new Date());
    this.today.startOf("week");
  },
  mounted() {
    this.getStaffs();
    this.getRiyousyas();
    this.getServices();
    this.setWeeks();

    this.getHolidays();
    this.getSyukins();
    this.getKoukai();

    let self = this;
    setTimeout(function() {
      self.kousin();
    }, 500);
  },
  methods: {
    holiupdate() {
      this.holidialog = false;
      var self = this;
      this.$axios
        .post(
          this.url + "updateHoliday.php",
          JSON.stringify({
            date: this.holidaydt,
            text: this.holiday
          })
        )
        .then(function() {
          self.msg = "更新しました。";
          if (self.msg !== "") {
            self.snackbar = true;
          }
          self.getHolidays();
        });
    },
    koukaiupdate() {
      var result = window.confirm("本当に公開してよろしいですか？");

      if (result) {
        var self = this;
        this.$axios
          .post(
            this.url + "updateKoukai.php",
            JSON.stringify({
              date: this.today
            })
          )
          .then(function() {
            self.msg = "公開しました。";
            if (self.msg !== "") {
              self.snackbar = true;
            }
            self.getKoukai();
          });
      }
    },
    syukinupdate() {
      this.syukindialog = false;
      var self = this;
      this.$axios
        .post(
          this.url + "updateSyukin.php",
          JSON.stringify({
            date: this.dayDt,
            staffid: this.dayId,
            text: this.syukinday,
            textsita: this.syukindaysita,
            yasumi: this.syukinyasumi
          })
        )
        .then(function() {
          self.msg = "更新しました。";
          if (self.msg !== "") {
            self.snackbar = true;
          }
          self.getSyukins();
        });
    },
    open(event) {
      if (!this.admin()) return false;
      this.dialog = true;
      this.ev = event;
    },
    dayopen(id, dt) {
      if (!this.admin()) return false;
      this.daydialog = true;
      this.dayMap = this.eventsMap[id][dt];
      if (this.dayMap === undefined) this.dayMap = [];
      this.dayDt = dt;
      this.dayId = id;
      this.selected = this.dayMap.slice();
    },
    holiopen(ydt) {
      if (!this.admin()) return false;
      this.daydialog = false;
      this.holidialog = true;
      this.holidaydt = ydt;
      this.holiday = this.getmemo(ydt);
    },
    syukinopen() {
      if (!this.admin()) return false;
      this.daydialog = false;
      this.syukindialog = true;
      this.syukinday = "";
      this.syukindaysita = "";
      this.syukindaysita = this.syukins[this.dayDt][this.dayId].textsita;
      this.syukinday = this.syukins[this.dayDt][this.dayId].text;
      this.syukinyasumi = this.syukins[this.dayDt][this.dayId].yasumi;
    },

    select(sel) {
      if (!sel.value && this.selected.includes(sel.item)) {
        this.selected = this.selected.filter(v => v !== sel.item);
      } else {
        this.selected.push(sel.item);
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dayMap.slice();
    },
    copy() {
      this.copyMap = this.selected;
      this.msg = "コピー完了しました。";
      this.daydialog = false;
      this.snackbar = true;
    },
    past() {
      this.msg = "貼り付け完了しました。";
      this.copyMap.forEach(v => {
        v.ins = true;
        v.cancel = false;
        v.date = this.dayDt;
        v.staffid = this.dayId;
        this.ev = v;
        this.update();
      });
      this.daydialog = false;
    },
    update() {
      this.dialog = false;
      this.ev.staffname = this.staffs.find(
        staff => staff.id === this.ev.staffid
      ).staffname;
      this.ev.riname = this.riyousyas.find(ri => ri.id === this.ev.riid).riname;
      var service = this.services.find(
        service => service.mark === this.ev.mark
      );
      if (!service) service = { mark: "" };
      this.ev.mark = service.mark;
      this.ev.service = service.id;
      this.ev.updid = this.$store.getters.userid;

      var self = this;
      this.$axios
        .post(
          this.url + "updateShift.php",
          JSON.stringify({
            upd: this.ev
          })
        )
        .then(function() {
          if (self.msg !== "") {
            self.snackbar = true;
          }
          self.kousin();
        });
    },
    cancel() {
      this.dialog = false;
      this.ev.cancel = !this.ev.cancel;
      this.msg = "キャンセルに設定しました。";
      this.update();
    },
    del() {
      this.dialog = false;
      this.ev.del = true;
      this.msg = "削除しました。";
      this.update();
    },
    add() {
      this.daydialog = false;
      this.dialog = true;
      this.ev = {};
      this.ev.date = this.dayDt;
      this.ev.ins = true;
    },
    kousin() {
      var self = this;
      self.getHolidays();
      self.getSyukins();
      self.getKoukai();
      self.getWeekTime();
      this.$axios
        .post(
          this.url + "shift.php",
          JSON.stringify({
            today: this.today.format("YYYY-MM-DD"),
            kaisi: "",
            syuryo: "",
            order: this.type,
            // id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.events = res.data;
          self.events.forEach(v => {
            v.time = v.kaisi;
            v.del = self.repBoolean(v.del);
            v.cancel = self.repBoolean(v.cancel);
          });
          const map = {};
          self.staffs.forEach(v => {
            map[v.id] = {};
            self.weeks.forEach(w => {
              var d = moment(w.ydt).format("YYYY-MM-DD");
              map[v.id][d] = [];
            });
          });
          self.events.forEach(v => {
            var dt = moment(v.date).format("YYYY-MM-DD");
            map[v.staffid][dt].push(v);
          });
          self.eventsMap = map;
        });
    },
    getHolidays() {
      var self = this;
      this.$axios
        .post(
          this.url + "getHolidays.php",
          JSON.stringify({
            role: this.$store.getters.auth.role,
            kaisi: moment(this.today).format("YYYY-MM-DD"),
            syuryo: moment(this.today)
              .add(1, "weeks")
              .format("YYYY-MM-DD")
          })
        )
        .then(function(res) {
          res.data.forEach(v => {
            //self.holidays[v.date] = v.text
            self.$set(self.holidays, v.date, v.text);
          });
        });
    },

    getWeekTime() {
      var self = this;
      self.weekTime = {};
      this.$axios
        .post(
          this.url + "getShiftsTimeWeek.php",
          JSON.stringify({
            role: this.$store.getters.auth.role,
            date: this.today.format("YYYY-MM-DD")
          })
        )
        .then(function(res) {
          res.data.forEach(v => {
            self.weekTime[v.staffid] = v.jikansa;
          });
        });
    },

    getKoukai() {
      var self = this;
      this.$axios
        .post(
          this.url + "getKoukai.php",
          JSON.stringify({
            date: this.today.format("YYYY-MM-DD")
          })
        )
        .then(function(res) {
          self.koukai = res.data.koukai;
        });
    },

    getSyukins() {
      var self = this;
      this.$axios
        .post(
          this.url + "getSyukins.php",
          JSON.stringify({
            role: this.$store.getters.auth.role,
            kaisi: moment(this.today).format("YYYY-MM-DD"),
            syuryo: moment(this.today)
              .add(1, "weeks")
              .format("YYYY-MM-DD")
          })
        )
        .then(function(res) {
          res.data.forEach(v => {
            if (!self.syukins[v.date]) self.syukins[v.date] = {};
            self.syukins[v.date][v.staffid] = {
              text: v.text,
              textsita: v.textsita,
              yasumi: v.yasumi
            };
            // self.$set(self.syukins, v.date, v.text);
          });
        });
    },
    getStaffs() {
      this.$axios.get(this.url + "getStaffs.php").then(response => {
        this.staffs = response.data;
        this.dokos = this.staffs.concat();
        this.dokos.unshift({ id: 0, staffname: "無し" });
      });
    },
    getRiyousyas() {
      this.$axios.get(this.url + "getRiyousyas.php").then(response => {
        this.riyousyas = response.data;
      });
    },
    getServices() {
      this.$axios.get(this.url + "getServices.php").then(response => {
        this.services = response.data;
      });
    },
    changeType() {
      this.kousin();
    },
    splitBlank(text) {
      if (text == null) return "";
      var r = text.replace("　", " ").split(" ")[0];
      return r;
    },
    repBoolean(text) {
      if (text == null) return false;
      if (text === "0") return false;
      if (!text) return false;
      return true;
    },
    getMonthName: function(month) {
      var monthName = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ];
      return monthName[month - 1];
    },
    weekDay: function(index) {
      return moment(this.today)
        .add(index, "d")
        .format("YYYY-MM-DD");
    },
    setWeeks: function() {
      this.weeks = [];
      var weekname = [
        { wnm: "日" },
        { wnm: "月" },
        { wnm: "火" },
        { wnm: "水" },
        { wnm: "木" },
        { wnm: "金" },
        { wnm: "土" }
      ];
      var sun = moment(this.today).startOf("week");
      weekname.forEach((v, i) => {
        v.ydt = moment(sun)
          .add(i, "d")
          .format("YYYY-MM-DD");
        v.dt = moment(sun)
          .add(i, "d")
          .format("MM-DD");
        v.wnm = weekname[i].wnm;
        this.weeks.push(v);
      });
    },
    moveLastMonth: function() {
      this.keyid = 0;
      this.today.add(-7, "d");
      this.setWeeks();
      this.kousin();
    },
    moveNextMonth: function() {
      this.keyid = 0;
      this.today.add(7, "d");
      this.setWeeks();
      this.kousin();
    },
    getmemo: function(dt) {
      if (!this.holidays[dt]) return "";
      return this.holidays[dt];
    },
    getsyukin: function(dt, id) {
      if (!this.syukins[dt] || !this.syukins[dt][id]) return "";
      return this.syukins[dt][id].text;
    },
    getsyukinsita: function(dt, id) {
      if (!this.syukins[dt] || !this.syukins[dt][id]) return "";
      return this.syukins[dt][id].textsita;
    },
    getyasumi: function(dt, id) {
      if (!this.syukins[dt] || !this.syukins[dt][id]) return "";
      if (this.syukins[dt][id].yasumi) return "休み";
      return "";
    }
  }
};
</script>

<style lang="stylus" scope>
.week {
}

p.evw {
  margin: 0;
  padding: 0;
  cursor: pointer;
  text-align: center;
}

p.day {
  margin-bottom: 0;
}

p.ev:hover {
  color: red;
  font-weight: bold;
}

p.cancel {
  text-decoration: line-through;
}

p.del {
  display: none;
}

/* カレンダーのスタイル */
.caldivweek {
  margin-top: 10px;
  min-width: 1300px;
}

.caldivweek .table, .caldivweek .table th, .caldivweek .table td {
  border: 1px solid gray;
}

.caldivweek .table {
  width: 100%;
  border-collapse: collapse;
}

.caldivweek .table th {
  padding: 5px 0px;
  width: 10%;
}

.caldivweek .table th.thname {
  background-color: navy;
  color: white;
}

.caldivweek .table td {
  padding: 2px 0px 2px 6px;
  width: 10%;
  vertical-align: top;
  cursor: pointer;
}

.caldivweek .table p.dt {
  margin: 0;
}

span.ym {
  font-size: 130%;
}

#wcalendar th:nth-child(2) {
  background-color: #FEEEFF;
  color: red;
}

#wcalendar td:nth-child(2) {
  background-color: #FEEEFF;
}

#wcalendar th:nth-child(8) {
  background-color: #DFFFFF;
  color: navy;
}

#wcalendar td:nth-child(8) {
  background-color: #DFFFFF;
}

#wcalendar td:hover {
}
</style>
